<template>
  <div class="top-menu-main">
    <menu-under-bar-modal :props-menu-lists="menu"></menu-under-bar-modal>
  </div>
</template>

<script>
import * as types from '../../store/mutation-types'
import MenuUnderBarModal from '../common/MenuUnderBarModal'

export default {
  name: 'top-menu-main',
  data() {
    return {
      menu: {
        0: {
          title: 'PORTFOLIO',
          name: 'portfolio',
          sort: 0
        },
        1: {
          title: 'DETAIL',
          name: 'detail',
          sort: 0
        },
        2: {
          title: 'REVIEWS',
          name: 'reviews',
          sort: 0
        }
        // 2: {
        //     title: 'LOCATION',
        //     name: 'location',
        //     sort: 0
        // },
      }
    }
  },
  components: {
    MenuUnderBarModal
  },
  methods: {
    signup() {
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: 'signup',
        active: true,
        type: 'full'
      })
    },
    request() {
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: 'requestPage',
        active: true,
        type: 'box'
      })
    },
    alert() {
      // console.log('click ', 1)
      this.$store.dispatch(types.SET_MODAL_ALERT, {
        active: true,
        text: '테스트 해봐요'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.top-menu-main {
  height: auto;
  width: 100%;
}
</style>
